import PageLayout from "../../components/page-layout";
import NotificationListTable from './components/NotificationListTable';

export default function NotificationListPage() {
  return (
    <PageLayout>
      <NotificationListTable />
    </PageLayout>
  );
}
